import { TeacherPin } from '@lessonup/pins-shared';
import { NonInteractiveView } from '../../playerStore.types';
import { advanceAnimationState, getAnimationSteps } from '../../utils/animations';
import { Direction } from '../reducers.types';

/**
 * This reducer accepts the pin directly rather than the whole state,
 * making it reusable across different player contexts (normal and self-paced).
 *
 * Non-interactive slides are static content that don't have phases or state
 * transitions, but they can have animations.
 */
export const sharedNonInteractiveReducer = {
  phases: ['base'] as const,
  initial: (history: NonInteractiveView | null): NonInteractiveView => ({
    type: 'NON_INTERACTIVE',
    phase: 'base',
    lastPlayedAnimationStep: history?.lastPlayedAnimationStep ?? null,
  }),
  hasNextView(pin: TeacherPin | null, currentView: NonInteractiveView, direction: Direction): boolean {
    return sharedNonInteractiveReducer.handleNextView(pin, currentView, direction) !== false;
  },
  handleNextView(
    pin: TeacherPin | null,
    currentView: NonInteractiveView,
    direction: Direction
  ): NonInteractiveView | false {
    if (!pin) {
      return false;
    }

    const animationSteps = getAnimationSteps(pin);
    const nextAnimationStep = advanceAnimationState(animationSteps, currentView.lastPlayedAnimationStep, direction);

    if (nextAnimationStep === false) {
      return false;
    }

    return { type: 'NON_INTERACTIVE', phase: 'base', lastPlayedAnimationStep: nextAnimationStep };
  },
};
